/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { DocumentiClonaForm } from '../model/documenti-clona-form';
// @ts-ignore
import { DocumentiOrdineForm } from '../model/documenti-ordine-form';
// @ts-ignore
import { DocumentoAdminDTO } from '../model/documento-admin-dto';
// @ts-ignore
import { DocumentoBozzaForm } from '../model/documento-bozza-form';
// @ts-ignore
import { DocumentoCorrezioneForm } from '../model/documento-correzione-form';
// @ts-ignore
import { DocumentoCorrezioneStoricoDTO } from '../model/documento-correzione-storico-dto';
// @ts-ignore
import { DocumentoVersionForm } from '../model/documento-version-form';
// @ts-ignore
import { DocumentoVersioneDettaglioDTO } from '../model/documento-versione-dettaglio-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    DocumentiDelComuneGestioneServiceInterface,
    ClonaDocumentiComuneBackofficeRequestParams,
    CorreggiDocumentoComuneVersioneBackofficeRequestParams,
    CreaDocumentoComuneBackofficeRequestParams,
    EliminaDocumentoComuneBackofficeRequestParams,
    EliminaDocumentoComuneBozzaBackofficeRequestParams,
    GetDocumentoComuneCorrezioniBackofficeRequestParams,
    GetDocumentoComuneVersioneBackofficeRequestParams,
    ListDocumentiComuneBackofficeRequestParams,
    PubblicaDocumentoComuneBozzaBackofficeRequestParams,
    RiordinaDocumentiComuneBackofficeRequestParams,
    RipristinaDocumentoComuneBackofficeRequestParams,
    RitiraDocumentoComuneBackofficeRequestParams,
    SalvaDocumentoComuneBozzaBackofficeRequestParams
} from './documenti-del-comune-gestione.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class DocumentiDelComuneGestioneService extends BaseService implements DocumentiDelComuneGestioneServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Clona i documenti attivi di un altro comune come bozze (SUPERADMIN).
     * Per ogni documento attivo della sorgente nasce nel comune un documento nuovo con una sola bozza (copia della versione corrente, o della bozza se non pubblicato). Niente viene pubblicato e il destinatario esistente non si tocca.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/clona
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public clonaDocumentiComuneBackoffice(requestParameters: ClonaDocumentiComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DocumentoAdminDTO>>;
    public clonaDocumentiComuneBackoffice(requestParameters: ClonaDocumentiComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DocumentoAdminDTO>>>;
    public clonaDocumentiComuneBackoffice(requestParameters: ClonaDocumentiComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DocumentoAdminDTO>>>;
    public clonaDocumentiComuneBackoffice(requestParameters: ClonaDocumentiComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling clonaDocumentiComuneBackoffice.');
        }
        const documentiClonaForm = requestParameters?.documentiClonaForm;
        if (documentiClonaForm === null || documentiClonaForm === undefined) {
            throw new Error('Required parameter documentiClonaForm was null or undefined when calling clonaDocumentiComuneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/clona`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DocumentoAdminDTO>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentiClonaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Corregge i refusi della versione corrente di un documento (SUPERADMIN).
     * Solo testi (titoli, testi, testo delle spunte): numero e spunte invariati, nessuna riaccettazione. Il contenuto precedente resta nello storico delle correzioni.
     * @endpoint put /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/versioni/{numero}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public correggiDocumentoComuneVersioneBackoffice(requestParameters: CorreggiDocumentoComuneVersioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoVersioneDettaglioDTO>;
    public correggiDocumentoComuneVersioneBackoffice(requestParameters: CorreggiDocumentoComuneVersioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoVersioneDettaglioDTO>>;
    public correggiDocumentoComuneVersioneBackoffice(requestParameters: CorreggiDocumentoComuneVersioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoVersioneDettaglioDTO>>;
    public correggiDocumentoComuneVersioneBackoffice(requestParameters: CorreggiDocumentoComuneVersioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling correggiDocumentoComuneVersioneBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling correggiDocumentoComuneVersioneBackoffice.');
        }
        const numero = requestParameters?.numero;
        if (numero === null || numero === undefined) {
            throw new Error('Required parameter numero was null or undefined when calling correggiDocumentoComuneVersioneBackoffice.');
        }
        const documentoCorrezioneForm = requestParameters?.documentoCorrezioneForm;
        if (documentoCorrezioneForm === null || documentoCorrezioneForm === undefined) {
            throw new Error('Required parameter documentoCorrezioneForm was null or undefined when calling correggiDocumentoComuneVersioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/versioni/${this.configuration.encodeParam({name: "numero", value: numero, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoVersioneDettaglioDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentoCorrezioneForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un documento con la sua prima bozza (SUPERADMIN).
     * Il documento nasce ATTIVO, in coda all\&#39;ordine, con una sola bozza; i cittadini non vedono nulla finche\&#39; non e\&#39; pubblicata.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public creaDocumentoComuneBackoffice(requestParameters: CreaDocumentoComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoAdminDTO>;
    public creaDocumentoComuneBackoffice(requestParameters: CreaDocumentoComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoAdminDTO>>;
    public creaDocumentoComuneBackoffice(requestParameters: CreaDocumentoComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoAdminDTO>>;
    public creaDocumentoComuneBackoffice(requestParameters: CreaDocumentoComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling creaDocumentoComuneBackoffice.');
        }
        const documentoBozzaForm = requestParameters?.documentoBozzaForm;
        if (documentoBozzaForm === null || documentoBozzaForm === undefined) {
            throw new Error('Required parameter documentoBozzaForm was null or undefined when calling creaDocumentoComuneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoAdminDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentoBozzaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina un documento mai pubblicato (SUPERADMIN).
     * Richiede il query param obbligatorio version &#x3D; version del documento.
     * @endpoint delete /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public eliminaDocumentoComuneBackoffice(requestParameters: EliminaDocumentoComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public eliminaDocumentoComuneBackoffice(requestParameters: EliminaDocumentoComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public eliminaDocumentoComuneBackoffice(requestParameters: EliminaDocumentoComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public eliminaDocumentoComuneBackoffice(requestParameters: EliminaDocumentoComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling eliminaDocumentoComuneBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling eliminaDocumentoComuneBackoffice.');
        }
        const version = requestParameters?.version;
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling eliminaDocumentoComuneBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'version',
            <any>version,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina la bozza di un documento (SUPERADMIN).
     * Se il documento non ha versioni pubblicate viene eliminato anche il documento. Richiede il query param obbligatorio version &#x3D; version della bozza.
     * @endpoint delete /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/bozza
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public eliminaDocumentoComuneBozzaBackoffice(requestParameters: EliminaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public eliminaDocumentoComuneBozzaBackoffice(requestParameters: EliminaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public eliminaDocumentoComuneBozzaBackoffice(requestParameters: EliminaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public eliminaDocumentoComuneBozzaBackoffice(requestParameters: EliminaDocumentoComuneBozzaBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling eliminaDocumentoComuneBozzaBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling eliminaDocumentoComuneBozzaBackoffice.');
        }
        const version = requestParameters?.version;
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling eliminaDocumentoComuneBozzaBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'version',
            <any>version,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bozza`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Storico delle correzioni di una versione (SUPERADMIN, OP_COMUNE).
     * Dalla piu\&#39; recente: quando, chi e il contenuto prima della correzione.
     * @endpoint get /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/versioni/{numero}/correzioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getDocumentoComuneCorrezioniBackoffice(requestParameters: GetDocumentoComuneCorrezioniBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DocumentoCorrezioneStoricoDTO>>;
    public getDocumentoComuneCorrezioniBackoffice(requestParameters: GetDocumentoComuneCorrezioniBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DocumentoCorrezioneStoricoDTO>>>;
    public getDocumentoComuneCorrezioniBackoffice(requestParameters: GetDocumentoComuneCorrezioniBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DocumentoCorrezioneStoricoDTO>>>;
    public getDocumentoComuneCorrezioniBackoffice(requestParameters: GetDocumentoComuneCorrezioniBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling getDocumentoComuneCorrezioniBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling getDocumentoComuneCorrezioniBackoffice.');
        }
        const numero = requestParameters?.numero;
        if (numero === null || numero === undefined) {
            throw new Error('Required parameter numero was null or undefined when calling getDocumentoComuneCorrezioniBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/versioni/${this.configuration.encodeParam({name: "numero", value: numero, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/correzioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DocumentoCorrezioneStoricoDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Una versione pubblicata di un documento, con i testi (SUPERADMIN, OP_COMUNE).
     * @endpoint get /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/versioni/{numero}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getDocumentoComuneVersioneBackoffice(requestParameters: GetDocumentoComuneVersioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoVersioneDettaglioDTO>;
    public getDocumentoComuneVersioneBackoffice(requestParameters: GetDocumentoComuneVersioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoVersioneDettaglioDTO>>;
    public getDocumentoComuneVersioneBackoffice(requestParameters: GetDocumentoComuneVersioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoVersioneDettaglioDTO>>;
    public getDocumentoComuneVersioneBackoffice(requestParameters: GetDocumentoComuneVersioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling getDocumentoComuneVersioneBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling getDocumentoComuneVersioneBackoffice.');
        }
        const numero = requestParameters?.numero;
        if (numero === null || numero === undefined) {
            throw new Error('Required parameter numero was null or undefined when calling getDocumentoComuneVersioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/versioni/${this.configuration.encodeParam({name: "numero", value: numero, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoVersioneDettaglioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Documenti di consenso del comune (SUPERADMIN, OP_COMUNE).
     * Per ordine, ritirati inclusi, con versione corrente e storico delle versioni pubblicate. La bozza e\&#39; sempre nulla per l\&#39;OP_COMUNE, che non vede i documenti mai pubblicati.
     * @endpoint get /api/v1/gestione/comuni/{id_comune}/documenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listDocumentiComuneBackoffice(requestParameters: ListDocumentiComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DocumentoAdminDTO>>;
    public listDocumentiComuneBackoffice(requestParameters: ListDocumentiComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DocumentoAdminDTO>>>;
    public listDocumentiComuneBackoffice(requestParameters: ListDocumentiComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DocumentoAdminDTO>>>;
    public listDocumentiComuneBackoffice(requestParameters: ListDocumentiComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling listDocumentiComuneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DocumentoAdminDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Pubblica la bozza di un documento (SUPERADMIN).
     * Numero di versione &#x3D; ultimo pubblicato + 1; richiede almeno una spunta. Richiede la version della bozza.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/bozza/pubblica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public pubblicaDocumentoComuneBozzaBackoffice(requestParameters: PubblicaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoAdminDTO>;
    public pubblicaDocumentoComuneBozzaBackoffice(requestParameters: PubblicaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoAdminDTO>>;
    public pubblicaDocumentoComuneBozzaBackoffice(requestParameters: PubblicaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoAdminDTO>>;
    public pubblicaDocumentoComuneBozzaBackoffice(requestParameters: PubblicaDocumentoComuneBozzaBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling pubblicaDocumentoComuneBozzaBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling pubblicaDocumentoComuneBozzaBackoffice.');
        }
        const documentoVersionForm = requestParameters?.documentoVersionForm;
        if (documentoVersionForm === null || documentoVersionForm === undefined) {
            throw new Error('Required parameter documentoVersionForm was null or undefined when calling pubblicaDocumentoComuneBozzaBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bozza/pubblica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoAdminDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentoVersionForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imposta l\&#39;ordine dei documenti del comune (SUPERADMIN).
     * La lista deve essere una permutazione esatta di tutti i documenti del comune.
     * @endpoint put /api/v1/gestione/comuni/{id_comune}/documenti/ordine
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public riordinaDocumentiComuneBackoffice(requestParameters: RiordinaDocumentiComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DocumentoAdminDTO>>;
    public riordinaDocumentiComuneBackoffice(requestParameters: RiordinaDocumentiComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DocumentoAdminDTO>>>;
    public riordinaDocumentiComuneBackoffice(requestParameters: RiordinaDocumentiComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DocumentoAdminDTO>>>;
    public riordinaDocumentiComuneBackoffice(requestParameters: RiordinaDocumentiComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling riordinaDocumentiComuneBackoffice.');
        }
        const documentiOrdineForm = requestParameters?.documentiOrdineForm;
        if (documentiOrdineForm === null || documentiOrdineForm === undefined) {
            throw new Error('Required parameter documentiOrdineForm was null or undefined when calling riordinaDocumentiComuneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/ordine`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DocumentoAdminDTO>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentiOrdineForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ripristina un documento ritirato (SUPERADMIN).
     * Chi ha accettato la versione corrente non deve riaccettare.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/ripristina
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ripristinaDocumentoComuneBackoffice(requestParameters: RipristinaDocumentoComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoAdminDTO>;
    public ripristinaDocumentoComuneBackoffice(requestParameters: RipristinaDocumentoComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoAdminDTO>>;
    public ripristinaDocumentoComuneBackoffice(requestParameters: RipristinaDocumentoComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoAdminDTO>>;
    public ripristinaDocumentoComuneBackoffice(requestParameters: RipristinaDocumentoComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling ripristinaDocumentoComuneBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling ripristinaDocumentoComuneBackoffice.');
        }
        const documentoVersionForm = requestParameters?.documentoVersionForm;
        if (documentoVersionForm === null || documentoVersionForm === undefined) {
            throw new Error('Required parameter documentoVersionForm was null or undefined when calling ripristinaDocumentoComuneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ripristina`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoAdminDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentoVersionForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ritira un documento (SUPERADMIN).
     * Esce dalla modale dei cittadini; lo storico delle accettazioni resta intatto.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/ritira
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ritiraDocumentoComuneBackoffice(requestParameters: RitiraDocumentoComuneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoAdminDTO>;
    public ritiraDocumentoComuneBackoffice(requestParameters: RitiraDocumentoComuneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoAdminDTO>>;
    public ritiraDocumentoComuneBackoffice(requestParameters: RitiraDocumentoComuneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoAdminDTO>>;
    public ritiraDocumentoComuneBackoffice(requestParameters: RitiraDocumentoComuneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling ritiraDocumentoComuneBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling ritiraDocumentoComuneBackoffice.');
        }
        const documentoVersionForm = requestParameters?.documentoVersionForm;
        if (documentoVersionForm === null || documentoVersionForm === undefined) {
            throw new Error('Required parameter documentoVersionForm was null or undefined when calling ritiraDocumentoComuneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ritira`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoAdminDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentoVersionForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea o aggiorna la bozza di un documento (SUPERADMIN).
     * version nulla e nessuna bozza &#x3D; crea la bozza della versione successiva; valorizzata &#x3D; aggiorna con optimistic lock. Le spunte sono sostituite in blocco.
     * @endpoint put /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/bozza
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public salvaDocumentoComuneBozzaBackoffice(requestParameters: SalvaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DocumentoAdminDTO>;
    public salvaDocumentoComuneBozzaBackoffice(requestParameters: SalvaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DocumentoAdminDTO>>;
    public salvaDocumentoComuneBozzaBackoffice(requestParameters: SalvaDocumentoComuneBozzaBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DocumentoAdminDTO>>;
    public salvaDocumentoComuneBozzaBackoffice(requestParameters: SalvaDocumentoComuneBozzaBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idComune = requestParameters?.idComune;
        if (idComune === null || idComune === undefined) {
            throw new Error('Required parameter idComune was null or undefined when calling salvaDocumentoComuneBozzaBackoffice.');
        }
        const idDocumento = requestParameters?.idDocumento;
        if (idDocumento === null || idDocumento === undefined) {
            throw new Error('Required parameter idDocumento was null or undefined when calling salvaDocumentoComuneBozzaBackoffice.');
        }
        const documentoBozzaForm = requestParameters?.documentoBozzaForm;
        if (documentoBozzaForm === null || documentoBozzaForm === undefined) {
            throw new Error('Required parameter documentoBozzaForm was null or undefined when calling salvaDocumentoComuneBozzaBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/comuni/${this.configuration.encodeParam({name: "idComune", value: idComune, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documenti/${this.configuration.encodeParam({name: "idDocumento", value: idDocumento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bozza`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DocumentoAdminDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: documentoBozzaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
